import React from "react";
import "../css/dashboard.css";
import "../css/client.css";
import ClientProfileMobile from "../component/ClientProfileMobile";
import TopTitleBannerMobileWithArrow from "../component/TopTitleBannerMobileWithArrow";
import { useParams } from "react-router-dom";

export default function ClientContentMobile(props) {
  const { id } = useParams();
  const clientId = props.clientId || id;

  return (
    <div className="right-container-mobile">
      <TopTitleBannerMobileWithArrow title={"Client profile"} />
      <ClientProfileMobile clientId={clientId} />
    </div>
  );
}
